import { render, staticRenderFns } from "./ingredients.vue?vue&type=template&id=39af291d&scoped=true&"
import script from "./ingredients.vue?vue&type=script&lang=js&"
export * from "./ingredients.vue?vue&type=script&lang=js&"
import style0 from "./ingredients.vue?vue&type=style&index=0&id=39af291d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39af291d",
  null
  
)

export default component.exports